<template>
  <div >
    <iframe :src="iframeUrl" style="height:100%; width:100%;margin:0;border:0;"> </iframe>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import bgImg from '@/assets/login-bg.png'
import bgImg from '@/assets/loginBg.jpg'
import loginImg from '@/assets/login-img.png'
import sybg from '@/assets/sybg.png'
import api from '../api'
import tools from '../utils/tools.js'
export default {
  data() {
    return {
      iframeUrl:''
      // https://www.exporegist.com/CrmDemoTest/dynamic/index.html?id=27&loginid=933&stfType=1&sign=7da1e7e63afe4df5b8a815d1387fb4af&project=ccdemov5
    }
  },
  computed: {

  },
  mounted() {
    this.getUrl()
  },

  watch: {},
  methods: {
    getUrl(){
      api.getdynamicboothmapurl({
        source:"下届",  //下届    本届
        language:"cn"
      }).then(res=>{
        // console.log(res.data)
        if(res.data.code == '200'){
            this.iframeUrl = res.data.data.dynamicUrl || ''
            // console.log('dddddddddddddd')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
